function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import Form from 'components/Form';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Table from 'components/Table';
import StandardActions from 'components/Form/StadardActions';
import DeleteIcon from 'svg/delete.svg';
import Loupe from 'svg/loupe-light.svg';
import AddIcon from 'svg/add.svg';
import App from 'modules/App';
import * as actions from '../../../../actions';
import * as selectors from '../../../../selectors';
import messages from '../../../../messages';
import * as constants from '../../../../constants';
import AddPayerModal from './AddPayerModal';
import ConfirmDeletePayerModal from './ConfirmDeletePayerModal';
import validatorRules from './validatorRules.json';
import styles from './Payers.pcss';
class PayersForm extends FormContainerAbstract {
    componentDidUpdate(prevProps) {
        if (prevProps.isUpdateInProgress && !this.props.isUpdateInProgress) {
            this.onSetShouldReset();
        }
        if (this.state.shouldReset && !this.props.isFetchInProgress) {
            this.onInitialize();
        }
        this.setFormStatus();
    }
    onSetShouldReset() {
        this.setState({
            shouldReset: true
        });
    }
    onSubmit() {
        this.props.onSetFormValue({
            id: 'names',
            value: this.payers
        });
        super.onSubmit();
    }
    onInitialize() {
        this.setState({
            formInitialState: JSON.parse(JSON.stringify(this.props.configurationPayers)),
            hasUnsavedChanges: false,
            search: '',
            confirmDeletePayerName: null,
            shouldReset: false
        });
        this.props.onSetFormValues(_object_spread({}, this.props.configurationPayers));
    }
    onReset() {
        this.props.onSetFormValues(_object_spread({}, this.props.configurationPayers));
        this.props.onFormErrors(null);
    }
    onClickDelete(payer) {
        this.setState({
            confirmDeletePayerName: payer
        });
        this.props.onOpenDeletePayerModal();
    }
    onDeletePayer() {
        this.props.onSetFormValue({
            id: 'names',
            value: filter(this.payers, (payer)=>payer !== this.state.confirmDeletePayerName)
        });
        this.props.onCloseDeletePayerModal();
    }
    onAddPayer(payer) {
        this.props.onSetFormValue({
            id: 'names',
            value: [
                ...this.payers,
                payer.name
            ]
        });
        this.props.onCloseAddPayerModal();
    }
    setFormStatus() {
        const hasUnsavedChanges = !isEqual(get(this.state.formInitialState, 'names', []).sort(), this.payers.sort());
        if (this.state.hasUnsavedChanges !== hasUnsavedChanges) {
            this.setState({
                hasUnsavedChanges
            });
            this.props.onHasUnsavedChangesChanged(hasUnsavedChanges);
        }
    }
    get schema() {
        return [
            {
                key: 'name',
                renderer: (payer)=>/*#__PURE__*/ _jsx("b", {
                        children: payer.name
                    })
            },
            {
                key: 'action',
                renderer: (payer)=>this.renderAction(payer)
            }
        ];
    }
    get payers() {
        return get(this.props.formValues, 'values.names', []);
    }
    get entities() {
        let entities = this.payers;
        if (this.state.search) {
            entities = filter(entities, (payer)=>payer.includes(this.state.search));
        }
        return entities.sort().map((name)=>({
                name,
                action: name
            }));
    }
    renderAddPayerButton() {
        return /*#__PURE__*/ _jsx(Button, {
            className: "btn--primary btn--filled",
            onClick: ()=>this.props.onOpenAddPayerModal(),
            children: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(AddIcon, {
                        className: styles.header__addButton__icon
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.addPayer))
                    })
                ]
            })
        });
    }
    renderSearch() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.header__search,
            children: [
                /*#__PURE__*/ _jsx(Input, {
                    placeholder: messages.placeholders.searchPayer,
                    value: this.state.search,
                    onChange: (input)=>this.setState({
                            search: input.value
                        })
                }),
                /*#__PURE__*/ _jsx(Loupe, {
                    className: styles.search__loupe
                })
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.header,
            children: [
                this.renderSearch(),
                this.renderAddPayerButton()
            ]
        });
    }
    renderAction(payer) {
        return /*#__PURE__*/ _jsx(DeleteIcon, {
            className: styles.deleteIcon,
            onClick: ()=>this.onClickDelete(payer.name)
        });
    }
    renderTableHeaders() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.table__headers,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "text--paragraph",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.payerName))
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "text--paragraph",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.action))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "text--paragraph",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.payerName))
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "text--paragraph",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.action))
                        })
                    ]
                })
            ]
        });
    }
    renderTable() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.renderTableHeaders(),
                /*#__PURE__*/ _jsx(Table, {
                    idKey: "name",
                    schema: this.schema,
                    entities: this.entities,
                    perPage: 20,
                    isPerPageOff: true,
                    isHeaderOff: true
                })
            ]
        });
    }
    renderAddPayerModal() {
        return /*#__PURE__*/ _jsx(AddPayerModal, {
            isInProgress: this.props.isAddCountryInProgress,
            payers: this.payers,
            languageOptions: this.props.languageOptions,
            hasErrors: this.props.hasAddCountryErrors,
            onAddPayer: (payer)=>this.onAddPayer(payer)
        });
    }
    renderDeletePayerModal() {
        if (!this.state.confirmDeletePayerName) return null;
        return /*#__PURE__*/ _jsx(ConfirmDeletePayerModal, {
            isInProgress: this.props.isDeleteCountryInProgress,
            hasErrors: this.props.hasDeleteCountryErrors,
            onDeletePayer: ()=>this.onDeletePayer()
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Form, {
                    onSubmit: ()=>this.onSubmit(),
                    onReset: ()=>this.onReset(),
                    children: [
                        this.renderHeader(),
                        this.renderTable(),
                        /*#__PURE__*/ _jsx(StandardActions, {
                            hasChanges: this.state.hasUnsavedChanges,
                            isInProgress: this.props.isUpdateInProgress || this.props.isFetchInProgress,
                            infoMessage: this.props.isConfiguredCountryActive ? messages.infos.saveOnActiveCountry : null
                        })
                    ]
                }),
                this.renderAddPayerModal(),
                this.renderDeletePayerModal()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            formInitialState: JSON.parse(JSON.stringify(this.props.configurationPayers)),
            hasUnsavedChanges: false,
            payers: [],
            search: '',
            confirmDeletePayerName: null,
            shouldReset: false
        };
        this.validatorRules = validatorRules;
        this.props.onSetFormValues(this.props.configurationPayers);
    }
}
_define_property(PayersForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    isFetchInProgress: PropTypes.bool.isRequired,
    // Explicit actions
    onOpenAddPayerModal: PropTypes.func,
    onCloseAddPayerModal: PropTypes.func,
    onOpenDeletePayerModal: PropTypes.func,
    onCloseDeletePayerModal: PropTypes.func,
    // Implicit props
    configurationPayers: PropTypes.object
}));
const mapStateToProps = (state)=>({
        formValues: App.selectors.formSelector(constants.CONFIGURE_COUNTRY_PAYERS_TAB_FORM)(state),
        configurationPayers: selectors.payers(state),
        isUpdateInProgress: selectors.isUpdateCountryConfigurationPayersInProgress(state),
        isConfiguredCountryActive: selectors.isConfiguredCountryActive(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.CONFIGURE_COUNTRY_PAYERS_TAB_FORM;
    return {
        onSubmit: (values)=>dispatch(actions.updateCountryConfigurationPayers(values)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName)),
        onOpenAddPayerModal: ()=>dispatch(App.actions.openModal(constants.ADD_PAYER_MODAL)),
        onCloseAddPayerModal: ()=>dispatch(App.actions.closeModal(constants.ADD_PAYER_MODAL)),
        onOpenDeletePayerModal: ()=>dispatch(App.actions.openModal(constants.DELETE_PAYER_MODAL)),
        onCloseDeletePayerModal: ()=>dispatch(App.actions.closeModal(constants.DELETE_PAYER_MODAL))
    };
};
const ConnectedPayersForm = connect(mapStateToProps, mapDispatchToProps)(PayersForm);
export default withStyles(styles)(ConnectedPayersForm);
